module.exports = __webpack_public_path__ + "img/trips-3-mobile.c11ebc4a.gif";